module.exports = __webpack_public_path__ + "img/index-qysl11.9e920ea4.png";